/*----------------------------------------------*/
/*----		検索画面用数字が上がってくアニメ------*/
/*----------------------------------------------*/
var count_monitor = setInterval("countup()",10);

countup = function(){
	count = $("#countup span").html();
	count++;
	if(count > 5)	count++;
	if(count > 20)	count++;
	if(count > 100)	count = count+3;

	$("#countup span").html(count);
	if($("#countup").data("count") < count){
		$("#countup span").html($("#countup").data("count"));
		clearInterval(count_monitor);
	}
}

/*----------------------------------------------*/
/*----		検索画面、検索数読み込みajax		------*/
/*----------------------------------------------*/
$(function(){
	$(".load_db_get_data_num").each(function(){
		var word = $(this).data("word");
		var filter = $(this).data("filter");
		var stock_flg = $(this).data("stock_flg");
		$(this).load("https://www.tirakita.com/sys/goods_search/goods_search_tag_num_ajax.php?search_query="+word+"&filter="+filter+"&stock_flg="+stock_flg);
	});
});

/*----------------------------------------------*/
/*----		カテゴリもっと見る		------*/
/*----------------------------------------------*/
$(function(){
	$('#category_div2').click(function(){
		$('#category_div2').hide();

		$('#category_div').removeClass("cate");
		$('#category_div').addClass("cate2");

	});
});

/*----------------------------------------------*/
/*----				並び替えの選択				------*/
/*----------------------------------------------*/
$(function(){
	$('#sort_select').change(function(){
		var url = $(this).val();
		console.log(url);
		if(url) window.location.href = url;
	});
});

/*----------------------------------------------*/
/*----				在庫切れ商品を表示する				------*/
/*----------------------------------------------*/
$(function(){
	$('#all_disp').change(function(){
		var url = $(this).val();
		console.log(url);
		if(url) window.location.href = url;
	});
});

/*----------------------------------------------*/
/*----		絞り込み選択のチェックボックス	------*/
/*----------------------------------------------*/
$(function(){
	$('.shiborikomi_checkbox').change(function(){
		var url = $(this).val();
		console.log(url);
		if(url) window.location.href = url;
	});
});



